<template>
  <div id="services-home">
    <h2>Services</h2>
    <div class="mb-4">
      <router-link :to="{ name: 'ServiceForm' }">
        <v-btn color="primary" class="mr-2">Ajouter un service</v-btn>
      </router-link>
    </div>
    <div v-if="loading" class="mt-8">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>
    <v-row v-if="!loading && services && services.length > 0">
      <v-col cols="12" sm="6" md="4" v-for="service in services" :key="service.id">
        <v-card outlined class="mb-4">
          <v-card-title class="font-weight-bold">{{ service.name }}</v-card-title>
          <v-card-text>
            <div class="mt-2">
              <router-link :to="{ name: 'ServiceLevelForm', params: { serviceId: service.id } }">
                <v-btn color="secondary" small>Ajouter un niveau de service</v-btn>
              </router-link>
            </div>
            <div v-if="serviceLevelsByService[service.id] && serviceLevelsByService[service.id].length">
              <v-card
                v-for="level in serviceLevelsByService[service.id]"
                :key="level.id"
                class="mb-2"
                outlined
                color="#f9f9f9"
              >
                <v-card-title class="text-body-2 font-weight-bold">
                  {{ level.level || "N/A" }}
                </v-card-title>
                <v-card-text>
                  <div>
                    <strong>Repas standards:</strong>
                    {{ level.nbStandardMeals != null ? level.nbStandardMeals : 0 }}
                  </div>
                  <div>
                    <strong>Repas sans porc:</strong>
                    {{ level.nbNoPorkMeals != null ? level.nbNoPorkMeals : 0 }}
                  </div>
                  <div>
                    <strong>Repas végétariens:</strong>
                    {{ level.nbVegetarianMeals != null ? level.nbVegetarianMeals : 0 }}
                  </div>
                  <div>
                    <strong>Animateurs:</strong>
                    {{ level.nbAnimators != null ? level.nbAnimators : 0 }}
                  </div>
                  <div>
                    <strong>Plateaux:</strong>
                    {{ level.nbTrays != null ? level.nbTrays : 0 }}
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <div>
              <strong>Commentaire:</strong>
              {{ service.comment }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div v-if="!loading && (!services || services.length === 0)" class="d-flex flex-column align-center py-10">
      <v-icon large>mdi-inbox-remove</v-icon>
      <p class="text-body-1 grey--text text--darken-1 my-2">Aucun service trouvé</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceList",
  data() {
    return {
      services: [],
      serviceLevels: [],
      loading: false,
    }
  },
  computed: {
    serviceLevelsByService() {
      // Group serviceLevels by service ID
      const map = {}
      for (const level of this.serviceLevels) {
        if (!map[level.service]) map[level.service] = []
        map[level.service].push(level)
      }
      return map
    },
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const [services, serviceLevels] = await Promise.all([
          this.$store.dispatch("fetchServices"),
          this.$store.dispatch("fetchServiceLevels"),
        ])
        this.services = services.results || services
        this.serviceLevels = serviceLevels.results || serviceLevels
      } finally {
        this.loading = false
      }
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>
